import { render } from "./ExtendedNav.vue?vue&type=template&id=1204c189&scoped=true"
import script from "./ExtendedNav.vue?vue&type=script&lang=js"
export * from "./ExtendedNav.vue?vue&type=script&lang=js"

import "./ExtendedNav.vue?vue&type=style&index=0&id=1204c189&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1204c189"

export default script